import React, { useState, useRef } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

function Contact() {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [treatmentType, setTreatmentType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const nameRef = useRef(null);
  const phoneNumberRef = useRef(null);
  const treatmentTypeRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name === "" || phoneNumber === "" || treatmentType === "") {
      if (name === "") {
        nameRef.current.focus();
      } else if (phoneNumber === "") {
        phoneNumberRef.current.focus();
      } else if (treatmentType === "") {
        treatmentTypeRef.current.focus();
      }
      return;
    }
    setError("");

    const whatsappNumber = "+972599599591";
    const text = `${t("contact.labels.name")}: ${name}%0A${t(
      "contact.labels.phone"
    )}: ${phoneNumber}%0A${t("contact.labels.email")}: ${email || "N/A"}%0A${t(
      "contact.labels.treatment"
    )}: ${treatmentType}%0A${t("contact.labels.message")}: ${
      message || treatmentType
    }`;
    const url = `https://wa.me/${whatsappNumber}?text=${text}`;
    window.open(url, "_blank");
  };

  return (
    <div className="contact overflow-hidden" id="contact">
      <motion.div
        className="container py-5"
        initial={{ opacity: 0, scale: 0.5, y: 0 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <Helmet>
          <title>{t("contact.seo.title")}</title>
          <meta name="description" content={t("contact.seo.description")} />
          <meta name="keywords" content={t("contact.seo.keywords")} />

          <meta property="og:title" content={t("contact.seo.ogTitle")} />
          <meta
            property="og:description"
            content={t("contact.seo.ogDescription")}
          />
          <meta
            property="og:image"
            content="https://via.placeholder.com/800x450.png?text=Contact+Slim+Smile"
          />
          <meta property="og:type" content="website" />
        </Helmet>

        {/* Heading */}

        <div className="head text-center">
          <h2 className="mb-4 fs-1 fw-bolder">{t("contact.heading")}</h2>
          <SVGTitle />
        </div>

        {error && <p className="text-danger">{error}</p>}

        {/* Form */}
        <div className="row mt-5">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="mb-3">
              <label htmlFor="name" className="form-label ms-2">
                {t("contact.labels.name")}
              </label>
              <input
                type="text"
                className="form-control"
                required
                id="name"
                placeholder={t("contact.placeholders.name")}
                value={name}
                onChange={(e) => setName(e.target.value)}
                ref={nameRef}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="phoneNumber" className="form-label ms-2">
                {t("contact.labels.phone")}
              </label>
              <input
                type="number"
                className="form-control"
                required
                id="phoneNumber"
                placeholder={t("contact.placeholders.phone")}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                ref={phoneNumberRef}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="treatmentType" className="form-label ms-2">
                {t("contact.labels.treatment")}
              </label>
              <select
                className="form-select"
                required
                value={treatmentType}
                onChange={(e) => setTreatmentType(e.target.value)}
                id="treatmentType"
                ref={treatmentTypeRef}
              >
                <option value="">
                  {t("contact.placeholders.selectTreatment")}
                </option>
                <option value={t("contact.treatments.implant")}>
                  {t("contact.treatments.implant")}
                </option>
                <option value={t("contact.treatments.cosmetic")}>
                  {t("contact.treatments.cosmetic")}
                </option>
                <option value={t("contact.treatments.orthodontics")}>
                  {t("contact.treatments.orthodontics")}
                </option>
                <option value={t("contact.treatments.preventive")}>
                  {t("contact.treatments.preventive")}
                </option>
              </select>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="mb-3">
              <label htmlFor="email" className="form-label ms-2">
                {t("contact.labels.email")}
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder={t("contact.placeholders.email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label ms-2">
                {t("contact.labels.message")}
              </label>
              <textarea
                className="form-control py-4"
                id="message"
                rows="3"
                placeholder={t("contact.placeholders.message")}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
          </div>

          <button
            onClick={handleSubmit}
            type="button"
            className="btn btn-info m-auto mt-3 text-dark"
            style={{ width: "fit-content" }}
          >
            {t("contact.button")}
            <i className="fa-brands fa-whatsapp me-2 text-success"></i>
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export default Contact;
